import { SubscribeService } from './services/data/subscribe.service';
import { CollectionsService } from './services/common/collections.service';
import { ConferenceService } from './services/data/conference.service';
import { UserService } from './services/auth/user.service';
import { SharedCompilationModule } from './shared/shared-compilation.module';
import { AuthGuardLoggedIn } from './services/auth/auth-guard-logged.service';
import { AuthService } from './services/auth/auth.service';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { AppRoutingModule } from './app.routing';
import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';
import { PrimengModule } from './primeng/primeng.module';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';

import { PersonService } from './services/data/person.service';
import { GeocodeService } from './services/data/geocode.service';
import { EditorModule, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';
import { FormsService } from './services/common/forms.service';
import { WrapperComponent } from './shared/components/wrapper/wrapper.component';
import { MergeService } from './services/data/merge.service';
import { IacmacService } from './services/data/iacmac.service';
import { TokenInterceptor } from './shared/interceptors/auth.interceptor';
import { ErrorInterceptor } from './shared/interceptors/error.interceptor';
import { AnonGuard } from './shared/guards/anon.guard';
import { AuthGuard } from './shared/guards/auth.guard';
import { AuthGuardAdmin } from './shared/guards/admin.guard';
import { AuthGuardRoot } from './shared/guards/root.guard';
import { UnsubscribeService } from './services/data/unsubscribe.service';
import { MarkdownModule } from 'ngx-markdown';
import { WrapperPublicComponent } from './shared/components/wrapper-public/wrapper-public.component';
import { RippleModule } from 'primeng/ripple';


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    WrapperComponent,
    WrapperPublicComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    RippleModule,
    // Others
    MarkdownModule.forRoot({ loader: HttpClientModule }),
    EditorModule,
    SharedCompilationModule,
    PrimengModule.forRoot(),
  ],
  providers: [
    AuthService,
    AuthGuardLoggedIn,
    // Guards
    AnonGuard,
    AuthGuard,
    AuthGuardAdmin,
    AuthGuardRoot,
    { provide: 'LOCALSTORAGE', useValue: window.localStorage },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.min.js' },
    UserService,
    ConferenceService,
    PersonService,
    MergeService,
    CollectionsService,
    IacmacService,
    UnsubscribeService,
    SubscribeService,
    FormsService,
    GeocodeService,
    // MetaDynamicService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
